import {endpoint} from "@/utils/api/Conf";
import {Prayers} from "@/types/Prayers";

export const spiritualityRequest = async (authToken: string, locale: string): Promise<Prayers | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
        "X-Language": locale || "it"
      }
    }
    const response = await fetch(endpoint + `readings?page_size=50`, init)
    if (!response.ok) {
      return false
    } else {
      return await response.json();
    }
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
